<div class="dashboard-material-theme download-metrics" fxLayout="column" fxLayoutAlign="center center">
  <h1>Choose a table format</h1>

  <div class="container">
    <div class="download-button" (click)="downloadVersionPQ()">
      <div class="horizontal">
        <span>Participants &#10230;</span>
        <div class="border"></div>
      </div>
      <div class="vertical">
        <div class="border"></div>
        <span>&#10229; Questions</span>
      </div>
      <div class="answers">Answers</div>
    </div>

    <div>OR</div>

    <div class="download-button" (click)="downloadVersionQP()">
      <div class="horizontal">
        <span>Questions &#10230;</span>
        <div class="border"></div>
      </div>
      <div class="vertical">
        <div class="border"></div>
        <span>&#10229; Participants</span>
      </div>
      <div class="answers">Answers</div>
    </div>
  </div>

</div>
